// Footer de branding del partner (footer_html — ej: "todos los derechos
// reservados"). Compartido por AuthShell y la pantalla de pago para no
// duplicar el markup + los estilos de los <a> embebidos.
//
// Renderiza null si el partner no definio footer_html o si el branding todavia
// no cargo. El HTML viene del BrandingConfig del backend (confiable).

import { useTheme } from '@/theme/ThemeProvider';

interface BrandFooterProps {
  className?: string;
}

export default function BrandFooter({ className = '' }: BrandFooterProps): JSX.Element | null {
  const { state } = useTheme();
  const footerHtml = state.status === 'ready' ? state.branding.footer_html : undefined;
  if (!footerHtml) return null;

  return (
    <footer
      className={`text-xs text-text-muted text-center [&_a]:text-accent [&_a:hover]:underline [&_a:focus-visible]:underline [&_a:focus-visible]:outline-none ${className}`}
      dangerouslySetInnerHTML={{ __html: footerHtml }}
    />
  );
}
